// import EconomicGroups from '@/views/group/EconomicGroups'
// import NewEconomicGroup from '@/views/group/NewEconomicGroup'
// import EditEconomicGroup from '@/views/group/EditEconomicGroup'
// import GroupBuyers from '@/views/group/GroupBuyers'
// import GroupProviders from '@/views/group/GroupProviders'
// import ManageBuyersGroup from '@/views/group/ManageBuyersGroup'
// import ManageProvidersGroup from '@/views/group/ManageProvidersGroup'
// import GroupRules from '@/views/group/GroupRules'
// import ProviderRules from '@/views/group/ProviderRules'
// import Index from '@/views/Index.vue';
const EconomicGroups = () => import('@/views/group/EconomicGroups');
const NewEconomicGroup = () => import('@/views/group/NewEconomicGroup');
const EditEconomicGroup = () => import('@/views/group/EditEconomicGroup');
//const GroupBuyers = () => import('@/views/group/GroupBuyers');
//const GroupProviders = () => import('@/views/group/GroupProviders');
const ManageBuyersGroup = () => import('@/views/group/ManageBuyersGroup');
const ManageProvidersGroup = () => import('@/views/group/ManageProvidersGroup');
const GroupRules = () => import('@/views/group/GroupRules');
const ProviderRules = () => import('@/views/group/ProviderRules');
const Index = () => import('@/views/Index.vue');

import getWhiteLabel from '@/utils/getWhiteLabel';

const groupRouter = {
    path: '/group',
    component: Index,
    name: 'economicGroup',
    meta: {
        requiresAuth: true
    },
    children: [{
            name: 'client/group',
            path: '/',
            component: EconomicGroups,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: 'new',
            component: NewEconomicGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/edit',
            component: EditEconomicGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/update',
            component: EditEconomicGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/buyer',
            component: ManageBuyersGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/provider',
            component: ManageProvidersGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        //{
        //    name: 'client/group',
        //    path: ':groupId/management/buyer',
        //    component: ManageBuyersGroup,
        //    meta: {
        //        title: `${getWhiteLabel()} - Grupos econômicos`,
        //        requiresAuth: true
        //    },
        //},
        //{
        //    name: 'client/group',
        //    path: ':groupId/management/provider',
        //    component: ManageProvidersGroup,
        //    meta: {
        //        title: `${getWhiteLabel()} - Grupos econômicos`,
        //        requiresAuth: true
        //    },
        //},
        {
            name: 'client/group',
            path: ':groupId/provider/:providerId/setting',
            component: ProviderRules,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/edit/buyer',
            component: ManageBuyersGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/edit/provider',
            component: ManageProvidersGroup,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/setting',
            component: GroupRules,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
        {
            name: 'client/group',
            path: ':groupId/edit/setting',
            component: GroupRules,
            meta: {
                title: `${getWhiteLabel()} - Grupos econômicos`,
                requiresAuth: true
            },
        },
    ]

}

export default groupRouter;